import script from "./LogIn.vue?vue&type=script&setup=true&lang=js"
export * from "./LogIn.vue?vue&type=script&setup=true&lang=js"

import "./LogIn.vue?vue&type=style&index=0&id=dfa6f71e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfa6f71e"]])

export default __exports__